module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', {
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousVendorView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h3', [_c('b', [_vm._v(_vm._s(_vm.editVar.FormVal) + " Service Estimation")])])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Estimation Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": _vm.checkStatus,
      "id": "Date"
    },
    model: {
      value: (_vm.serviceDetails.serviceEstimationDate),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "serviceEstimationDate", $$v)
      },
      expression: "serviceDetails.serviceEstimationDate"
    }
  }), _vm._v(" "), (!_vm.serviceDetails.serviceEstimationDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.serviceEstimationDateError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Supervisor Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "requestedBy",
      "name": "requestedBy",
      "disabled": true
    },
    model: {
      value: (_vm.serviceDetails.requestedBy),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "requestedBy", $$v)
      },
      expression: "serviceDetails.requestedBy"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "maintenanceType"
    }
  }, [_vm._v("Select Maintenance Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.MaintainList,
      "isDisabled": _vm.serviceDetails.serviceEstimationId != '',
      "option-value": "MVal",
      "option-text": "MText",
      "placeholder": "Select Type"
    },
    on: {
      "selected": function($event) {
        _vm.hideVehicle()
      },
      "input": function($event) {
        _vm.emptyVehicleDetails()
      }
    },
    model: {
      value: (_vm.serviceDetails.maintenanceType),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "maintenanceType", $$v)
      },
      expression: "serviceDetails.maintenanceType"
    }
  }), _vm._v(" "), (!_vm.serviceDetails.maintenanceType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.maintenanceTypeError))]) : _vm._e()], 1), _vm._v(" "), (
    _vm.serviceDetails.maintenanceType == 'Vehicle' &&
    _vm.serviceDetails.serviceEstimationId == ''
  ) ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "maintenanceType"
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.vehicleMasterList,
      "isDisabled": _vm.checkStatus,
      "option-value": "vehicleTruckId",
      "option-text": "regdNo",
      "placeholder": "Select Vehicle "
    },
    on: {
      "input": function($event) {
        _vm.emptyOdometerReading()
      }
    },
    model: {
      value: (_vm.VehicleAuto),
      callback: function($$v) {
        _vm.VehicleAuto = $$v
      },
      expression: "VehicleAuto"
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.serviceDetails.maintenanceType == 'Vehicle' &&
    _vm.serviceDetails.serviceEstimationId != ''
  ) ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Vehicle No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vehicleNo",
      "name": "vehicleNo",
      "disabled": ""
    },
    model: {
      value: (_vm.serviceDetails.vehicleNo),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "vehicleNo", $$v)
      },
      expression: "serviceDetails.vehicleNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.serviceDetails.maintenanceType == 'Yard') ? _c('b-col', {
    staticClass: "ml-4",
    attrs: {
      "md": "2",
      "md-flex": "10"
    }
  }, [_c('label', [_vm._v("Vehicle No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vehicleYard",
      "name": "vehicleYard",
      "disabled": _vm.checkStatus
    },
    model: {
      value: (_vm.serviceDetails.vehicleYard),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "vehicleYard", $$v)
      },
      expression: "serviceDetails.vehicleYard"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.serviceDetails.maintenanceType == 'Vehicle') ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Odometer Reading")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "odometre_Reading",
      "name": "odometre_Reading",
      "type": "number",
      "min": "0",
      "disabled": _vm.serviceDetails.serviceEstimationId != ''
    },
    model: {
      value: (_vm.serviceDetails.odometre_Reading),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "odometre_Reading", $$v)
      },
      expression: "serviceDetails.odometre_Reading"
    }
  }), _vm._v(" "), (!_vm.serviceDetails.odometre_Reading) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.odometreReadingError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.serviceDetails.maintenanceType == 'Vehicle') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Driver Complain")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "driver_complain",
      "name": "driver_complain"
    },
    model: {
      value: (_vm.serviceDetails.driver_complain),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "driver_complain", $$v)
      },
      expression: "serviceDetails.driver_complain"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.serviceDetails.maintenanceType == 'Vehicle') ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "maintenanceType"
    }
  }, [_vm._v("Nature of Job")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.jobNatureList,
      "option-value": "natureVal",
      "option-text": "natureText",
      "placeholder": "Select Job Nature"
    },
    model: {
      value: (_vm.serviceDetails.job_nature),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "job_nature", $$v)
      },
      expression: "serviceDetails.job_nature"
    }
  }), _vm._v(" "), (!_vm.serviceDetails.job_nature) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.job_natureError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.serviceDetails.maintenanceType == 'Vehicle') ? _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Engine No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "engineNo",
      "name": "engineNo",
      "disabled": _vm.serviceDetails.maintenanceType == 'Yard' ? _vm.checkStatus : true
    },
    model: {
      value: (_vm.serviceDetails.engineNo),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "engineNo", $$v)
      },
      expression: "serviceDetails.engineNo"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Chassis No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "chassisNo",
      "name": "chassisNo",
      "disabled": _vm.serviceDetails.maintenanceType == 'Yard' ? _vm.checkStatus : true
    },
    model: {
      value: (_vm.serviceDetails.chassisNo),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "chassisNo", $$v)
      },
      expression: "serviceDetails.chassisNo"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Purchase Year")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "yearOfPurchase",
      "name": "yearOfPurchase",
      "disabled": _vm.serviceDetails.maintenanceType == 'Yard' ? _vm.checkStatus : true
    },
    model: {
      value: (_vm.serviceDetails.yearOfPurchase),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "yearOfPurchase", $$v)
      },
      expression: "serviceDetails.yearOfPurchase"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Driver Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "driverName",
      "name": "driverName",
      "disabled": _vm.serviceDetails.maintenanceType == 'Yard' ? _vm.checkStatus : true
    },
    model: {
      value: (_vm.serviceDetails.driverName),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "driverName", $$v)
      },
      expression: "serviceDetails.driverName"
    }
  })], 1), _vm._v(" "), (_vm.serviceDetails.serviceEstimationId != '') ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "16%"
    },
    attrs: {
      "variant": "primary",
      "id": "vehicleHistoryButton",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.showVehicleHistory(_vm.serviceDetails.vehicleTruckId, 'Normal')
      }
    }
  }, [_vm._v("\n            Show vehicle History\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    (_vm.serviceDetails.approvedStatus == 'Pending' ||
      _vm.serviceDetails.approvedStatus == 'Rejected' ||
      _vm.serviceDetails.approvedStatus == '') &&
    _vm.serviceDetails.onRejectStatus != '3'
  ) ? _c('b-row', {
    staticClass: "mt-4 ml-2"
  }, [_c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('h4', {
    staticClass: "mt-2"
  }, [_c('b', [_vm._v(_vm._s(_vm.itemModal.itemForServiceEstId == "" ? "Add" : "Edit") + " Items")])])]) : _vm._e(), _vm._v(" "), (
    (_vm.serviceDetails.approvedStatus == 'Pending' ||
      _vm.serviceDetails.approvedStatus == 'Rejected' ||
      _vm.serviceDetails.approvedStatus == '' ||
      ((_vm.serviceDetails.approvedStatus == 'Sent For Approval' ||
          _vm.serviceDetails.approvedStatus == 'on_Hold') &&
        _vm.userLevel == '1')) &&
    _vm.serviceDetails.onRejectStatus != '3'
  ) ? _c('b-row', [(_vm.itemModal.itemForServiceEstId == '') ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "itemMasterList"
    }
  }, [_vm._v("Item Name - Part Number")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.itemMasterList,
      "disabled": _vm.itemModal.itemForServiceEstId != '',
      "option-value": "itemId",
      "option-text": "displayList",
      "placeholder": "Select Item"
    },
    model: {
      value: (_vm.itemAuto),
      callback: function($$v) {
        _vm.itemAuto = $$v
      },
      expression: "itemAuto"
    }
  }), _vm._v(" "), (!_vm.itemModal.itemCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.itemCodeError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Item Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "itemName",
      "name": "itemName",
      "disabled": ""
    },
    model: {
      value: (_vm.itemModal.itemName),
      callback: function($$v) {
        _vm.$set(_vm.itemModal, "itemName", $$v)
      },
      expression: "itemModal.itemName"
    }
  }), _vm._v(" "), (!_vm.itemModal.itemName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.itemNameError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Required Quantity")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.itemModal.itemUnitQ == 'pcs' ? true : false,
      "formatter": _vm.capitalizeAll,
      "id": "itemQuantity",
      "name": "itemQuantity",
      "type": "number",
      "min": "0"
    },
    on: {
      "keyup": _vm.finalAmount
    },
    model: {
      value: (_vm.itemModal.itemQuantity),
      callback: function($$v) {
        _vm.$set(_vm.itemModal, "itemQuantity", $$v)
      },
      expression: "itemModal.itemQuantity"
    }
  }), _vm._v(" "), (!_vm.itemModal.itemQuantity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.itemQuantityError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.itemModal.remark),
      callback: function($$v) {
        _vm.$set(_vm.itemModal, "remark", $$v)
      },
      expression: "itemModal.remark"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "16%"
    },
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("\n            " + _vm._s(_vm.itemModal.itemForServiceEstId == "" ? "Add Item" : "Update Item") + "\n          ")]), _vm._v(" "), (!_vm.serviceDetails.itemForServiceEstId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.additemError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.itemServiceDetails.length > 0 && _vm.userLevel != '1') ? _c('div', {
    staticClass: "table-responsive mt-2",
    staticStyle: {
      "background": "beige"
    }
  }, [_c('h5', {
    staticClass: "ml-2 py-2"
  }, [_c('b', [_vm._v("Requried Items Details :")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "serviceEstimateItem"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Item Name")]), _vm._v(" "), _c('th', [_vm._v("Quantity Available")]), _vm._v(" "), _c('th', [_vm._v("Quantity Requested")]), _vm._v(" "), _c('th', [_vm._v("Creation Date")]), _vm._v(" "), (
    _vm.serviceDetails.requestStatus == 'Rejected' ||
    _vm.serviceDetails.requestStatus == ''
  ) ? _c('th', [_vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), (
    _vm.serviceDetails.requestStatus == 'Rejected' ||
    _vm.serviceDetails.requestStatus == ''
  ) ? _c('th', [_vm._v("\n                Delete\n              ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemServiceDetails), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(parseInt(item.quantity) - parseInt(item.stockOut) <= 0 ? 0 : parseInt(item.quantity) -
      parseInt(item.stockOut)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemQuantity))]), _vm._v(" "), (item.stockOutFlag != 1) ? _c('td', [(
      parseInt(item.quantity) - parseInt(item.stockOut) > 0 &&
      item.stockOutFlag != 1 &&
      parseInt(item.itemQuantity) >
      parseInt(item.quantity) - parseInt(item.stockOut) ==
      false
    ) ? _c('md-switch', {
      staticClass: "md-primary",
      attrs: {
        "id": 'approval' + index,
        "name": "approval"
      },
      on: {
        "change": function($event) {
          _vm.fetchAndApprove(
            item.itemId,
            'yes',
            item.itemQuantity,
            index,
            'no',
            item.itemForServiceEstId
          )
        }
      },
      model: {
        value: (_vm.checked4[index].value),
        callback: function($$v) {
          _vm.$set(_vm.checked4[index], "value", $$v)
        },
        expression: "checked4[index].value"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.checked4[index].value == true ? "Approved" : "Not Approved") + "\n                ")]) : _vm._e(), _vm._v(" "), (
      parseInt(item.itemQuantity) >
      parseInt(item.quantity) - parseInt(item.stockOut) ==
      true && parseInt(item.quantity) - parseInt(item.stockOut) > 0
    ) ? _c('span', {
      staticClass: "warning"
    }, [_c('b', [_vm._v(_vm._s("Requested Quantity is more than Available quantity!"))])]) : _vm._e(), _vm._v(" "), (parseInt(item.quantity) - parseInt(item.stockOut) <= 0) ? _c('span', {
      staticClass: "error"
    }, [_c('b', [_vm._v(_vm._s("Requested Item Out of Stock !"))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.stockOutFlag == 1) ? _c('td', [_c('span', {
      staticClass: "success"
    }, [_c('b', [_vm._v("\n                    Service Estimation is already APPROVED & the requested quantity is\n                    Stocked-Out")])])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))]), _vm._v(" "), (
      _vm.serviceDetails.requestStatus == 'Rejected' ||
      _vm.serviceDetails.requestStatus == ''
    ) ? _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      attrs: {
        "disabled": _vm.serviceDetails.approvedStatus == 'Sent For Approval'
      },
      on: {
        "click": function($event) {
          _vm.viewModalPage(item.itemForServiceEstId)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), (
      _vm.serviceDetails.requestStatus == 'Rejected' ||
      _vm.serviceDetails.requestStatus == ''
    ) ? _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      attrs: {
        "disabled": _vm.serviceDetails.approvedStatus == 'Sent For Approval'
      },
      on: {
        "click": function($event) {
          _vm.deleteData(item.itemForServiceEstId)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.itemServiceDetails.length > 0 && _vm.userLevel == '1') ? _c('div', {
    staticClass: "table-responsive mt-4",
    staticStyle: {
      "background": "beige"
    }
  }, [_c('h5', {
    staticClass: "ml-2 py-2 pt-3"
  }, [_c('b', [_vm._v("Requried Items Details :")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "serviceEstimateItem1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Item Name")]), _vm._v(" "), _c('th', [_vm._v("Quantity Available")]), _vm._v(" "), _c('th', [_vm._v("Quantity Requested")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Creation Date")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemServiceDetails), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.itemName) + "\n                "), _c('br'), _vm._v(" "), (
      item.itemUnit == 'pcs' &&
      item.itemId &&
      !(
        parseInt(item.itemQuantity) >
        parseInt(item.quantity) - parseInt(item.stockOut) ==
        true && parseInt(item.quantity) - parseInt(item.stockOut) > 0
      ) &&
      !(parseInt(item.quantity) - parseInt(item.stockOut) <= 0)
    ) ? _c('b-button', {
      staticClass: "py-2",
      attrs: {
        "variant": "primary",
        "size": "sm",
        "id": "addButtonLoader"
      },
      on: {
        "click": function($event) {
          _vm.openUpdateSubItemModal(item)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item.itemId ? "Sub Item's" : "Sub Item's") + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(parseInt(item.quantity) - parseInt(item.stockOut) <= 0 ? 0 : parseInt(item.quantity) -
      parseInt(item.stockOut)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemQuantity)), (item.itemQuantityUnitMinus) ? _c('span', [_vm._v("/" + _vm._s(item.itemQuantityUnitMinus))]) : _vm._e()]), _vm._v(" "), (item.stockOutFlag != 1) ? _c('td', [(
      parseInt(item.quantity) - parseInt(item.stockOut) > 0 &&
      item.stockOutFlag != 1 &&
      parseInt(item.itemQuantity) >
      parseInt(item.quantity) - parseInt(item.stockOut) ==
      false
    ) ? _c('md-switch', {
      staticClass: "md-primary",
      attrs: {
        "id": 'approval' + index,
        "name": "approval"
      },
      on: {
        "change": function($event) {
          _vm.fetchAndApprove(
            item.itemId,
            'yes',
            item.itemQuantity,
            index,
            'no',
            item.itemForServiceEstId
          )
        }
      },
      model: {
        value: (_vm.checked4[index].value),
        callback: function($$v) {
          _vm.$set(_vm.checked4[index], "value", $$v)
        },
        expression: "checked4[index].value"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.checked4[index].value == true ? "Approved" : "Not Approved") + "\n                ")]) : _vm._e(), _vm._v(" "), (
      parseInt(item.itemQuantity) >
      parseInt(item.quantity) - parseInt(item.stockOut) ==
      true && parseInt(item.quantity) - parseInt(item.stockOut) > 0
    ) ? _c('span', {
      staticClass: "warning"
    }, [_c('b', [_vm._v(_vm._s("Requested Quantity is more than Available quantity!"))])]) : _vm._e(), _vm._v(" "), (parseInt(item.quantity) - parseInt(item.stockOut) <= 0) ? _c('span', {
      staticClass: "error"
    }, [_c('b', [_vm._v(_vm._s("Requested Item Out of Stock !"))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.stockOutFlag == 1) ? _c('td', [_c('span', {
      staticClass: "success"
    }, [_c('b', [_vm._v("\n                    Service Estimation is already APPROVED & the requested quantity is\n                    Stocked-Out")])])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))]), _vm._v(" "), _c('td', [(item.stockOutFlag != 1) ? _c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewModalPage(item.itemForServiceEstId)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1) : _vm._e()], 1)])
  }))])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "Sub-Item-Modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'Sub Item List'
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.PS_subItemList,
      "fields": _vm.PS_subItemFields
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1))])]
      }
    }, {
      key: "is_quanity",
      fn: function(row1) {
        return [_c('div', {
          attrs: {
            "id": 'row' + row1.item.lead_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row1.item.lead_id,
            "name": "approval",
            "value": row1.item.is_quanity == 1 ? true : false,
            "disabled": (row1.item.is_quanity == 1 && row1.item.se_sub_item_id) ?
              true :
              false
          },
          on: {
            "change": function($event) {
              _vm.isQuanityMinus(row1.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.is_quanity == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row1.item.is_quanity == 1 ?
          "Done" : "Pending"))])], 1)])], 1)]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "outline-danger",
      "size": "xs"
    },
    on: {
      "click": _vm.hideSubItemModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "confirm_modal_main",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "lg",
      "title": "Confirm Service Estimation Approval !",
      "centered": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "warning"
  }, [_c('b', [_vm._v("\n              Once Estimation is Approved, the requested quantity gets stocked out\n            ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_c('b', [_vm._v(" Note: User cannot undo Estimation Approval once Confirmed")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2%",
      "text-align": "center"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.cancleApproval()
      }
    }
  }, [_vm._v(" Reject ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.fetchAndApprove(
          _vm.selecteditemId,
          'yes',
          _vm.reqQuantity,
          _vm.quantityIndex,
          'yes',
          _vm.itemForServiceEstId
        );
        _vm.confirmApproval();
      }
    }
  }, [_vm._v("\n            Confirm Approval")])], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "confirm_modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "m",
      "title": "Confirm the check-out of Selected Item !",
      "centered": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "28%"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.cancelConfirmation()
      }
    }
  }, [_vm._v(" Cancel ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.confirmed()
      }
    }
  }, [_vm._v(" Confirm ")])], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "Item-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "title": "Available Sub Item List",
      "centered": ""
    }
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.fetchAndApprove(
          _vm.selecteditemId,
          '',
          _vm.reqQuantity,
          _vm.quantityIndex,
          'no',
          _vm.itemForServiceEstId
        )
      }
    }
  }, [_vm._v("\n            All Items\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.fetchAndApprove(
          _vm.selecteditemId,
          'yes',
          _vm.reqQuantity,
          _vm.quantityIndex,
          'no',
          _vm.itemForServiceEstId
        )
      }
    }
  }, [_vm._v("\n            Show Only Stocked-In items\n          ")]), _vm._v(" "), _c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search sub Item"
    },
    model: {
      value: (_vm.subItemfilter),
      callback: function($$v) {
        _vm.subItemfilter = $$v
      },
      expression: "subItemfilter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.subItemfilter
    },
    on: {
      "click": function($event) {
        _vm.subItemfilter = ''
      }
    }
  }, [_vm._v("Clear")])], 1), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRowsSubItem) + " Sub Items")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.subItemList,
      "fields": _vm.subItemfields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPageSubItem,
      "filter": _vm.subItemfilter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onSubItemFiltered
    },
    scopedSlots: _vm._u([{
      key: "itemId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPageSubItem))])]
      }
    }, {
      key: "subItemName",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.sub_item_name))])]
      }
    }, {
      key: "serialNo",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.sub_item_code))])]
      }
    }, {
      key: "installationDate",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.installation_date))])]
      }
    }, {
      key: "manufacturingDate",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.manufacture_date))])]
      }
    }, {
      key: "expiryDate",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.expiry_date))])]
      }
    }, {
      key: "stockReceivedDate",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.sub_item_received_date))])]
      }
    }, {
      key: "stockReceivedBy",
      fn: function(row7) {
        return [_c('span', [_vm._v(_vm._s(row7.item.receivedBy))])]
      }
    }, {
      key: "stockoutdate",
      fn: function(row8) {
        return [_c('span', [_vm._v(_vm._s(row8.item.sub_item_stockout_date))])]
      }
    }, {
      key: "checkOut",
      fn: function(row9) {
        return [(row9.item.isChecked_Out == 'no') ? _c('b-form-checkbox', {
          attrs: {
            "disabled": _vm.isCheckboxDisabled(row9.item)
          },
          on: {
            "change": function($event) {
              _vm.showConfirmationModal(row9.item)
            }
          },
          model: {
            value: (row9.item.isChecked_Out),
            callback: function($$v) {
              _vm.$set(row9.item, "isChecked_Out", $$v)
            },
            expression: "row9.item.isChecked_Out"
          }
        }) : _c('span', {
          staticClass: "error"
        }, [_vm._v(_vm._s(row9.item.isChecked_Out))])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRowsSubItem,
      "per-page": _vm.perPageSubItem
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "vehicle-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "title": "Vehicle History List",
      "centered": ""
    }
  }, [(!_vm.showRequiredItemsList) ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Vehicle No. / Series / Approval / Complain"
    },
    model: {
      value: (_vm.vehicleHistoryfilter),
      callback: function($$v) {
        _vm.vehicleHistoryfilter = $$v
      },
      expression: "vehicleHistoryfilter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.vehicleHistoryfilter
    },
    on: {
      "click": function($event) {
        _vm.vehicleHistoryfilter = ''
      }
    }
  }, [_vm._v("Clear")])], 1), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRowsVehicleHistory) + " History Entries")]) : _vm._e()])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [(!_vm.showRequiredItemsList) ? _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.vehicleHistoryList,
      "fields": _vm.vehicleHistoryFields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPageVehicleHistory,
      "filter": _vm.vehicleHistoryfilter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onvehicleHistoryFiltered
    },
    scopedSlots: _vm._u([{
      key: "vehicleId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPageVehicleHistory))])]
      }
    }, {
      key: "vehicleNo",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.vehicleNo))])]
      }
    }, {
      key: "serviceEstSeries",
      fn: function(row2) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewRequiredItemList(row2.item.itemForServiceEstId)
            }
          }
        }, [_vm._v("\n                " + _vm._s(row2.item.serviceEstSeries) + "\n              ")])]
      }
    }, {
      key: "driverName",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.driverName))])]
      }
    }, {
      key: "estimationDate",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.serviceEstDate))])]
      }
    }, {
      key: "odometreReading",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.odometre_Reading) + "\n                "), (row5.item.odometre_Reading != null) ? _c('small', [_vm._v(" km")]) : _vm._e()])]
      }
    }, {
      key: "driverComplain",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.driver_complain))])]
      }
    }, {
      key: "approvedStatus",
      fn: function(row7) {
        return [(row7.item.approvedStatus == 'Approved') ? _c('span', {
          staticClass: "success"
        }, [_vm._v(_vm._s(row7.item.approvedStatus))]) : _c('span', {
          staticClass: "error"
        }, [_vm._v(_vm._s(row7.item.approvedStatus))])]
      }
    }, {
      key: "approvedBy",
      fn: function(row8) {
        return [_c('span', [_vm._v(_vm._s(row8.item.approvedBy))])]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredItemsList) ? _c('b-button', {
    staticClass: "mb-2 mt-2 ml-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.gobackToVehicleHistory()
      }
    }
  }, [_vm._v("\n            Go back to Vehicle History\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showRequiredItemsList) ? _c('large', {
    staticClass: "pull-right mt-3 mr-2"
  }, [_vm._v("\n            Vehicle No.: "), _c('b', {
    staticClass: "warning"
  }, [_vm._v(_vm._s(_vm.serviceDetails.vehicleNo))])]) : _vm._e(), _vm._v(" "), (_vm.showRequiredItemsList) ? _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.itemServiceDetails,
      "fields": _vm.itemServiceDetailsFields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPageItemServiceDetails,
      "filter": _vm.itemServiceDetailsfilter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "itemId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPageItemServiceDetails))])]
      }
    }, {
      key: "itemName",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.itemName))])]
      }
    }, {
      key: "quantity",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.quantity))])]
      }
    }, {
      key: "itemQuantity",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.itemQuantity))])]
      }
    }, {
      key: "loginTime",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.loginTime))])]
      }
    }, {
      key: "approvedStatus",
      fn: function(row7) {
        return [(row7.item.approvedStatus == 'Approved') ? _c('span', {
          staticClass: "success"
        }, [_vm._v(_vm._s(row7.item.approvedStatus))]) : _c('span', {
          staticClass: "error"
        }, [_vm._v(_vm._s(row7.item.approvedStatus))])]
      }
    }, {
      key: "approvedBy",
      fn: function(row8) {
        return [_c('span', [_vm._v(_vm._s(row8.item.approvedBy))])]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [(!_vm.showRequiredItemsList) ? _c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRowsVehicleHistory,
      "per-page": _vm.perPageVehicleHistory
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.userLevel == '1' && this.serviceDetails.serviceEstimationId != '') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Manager Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "approvedBy",
      "name": "approvedBy",
      "disabled": ""
    },
    model: {
      value: (_vm.serviceDetails.approvedBy),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "approvedBy", $$v)
      },
      expression: "serviceDetails.approvedBy"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "maintenanceType"
    }
  }, [_vm._v("Update Estimation Request")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.UStatusList,
      "option-value": "USVal",
      "option-text": "USText",
      "placeholder": "Select "
    },
    model: {
      value: (_vm.serviceDetails.requestStatus),
      callback: function($$v) {
        _vm.$set(_vm.serviceDetails, "requestStatus", $$v)
      },
      expression: "serviceDetails.requestStatus"
    }
  }), _vm._v(" "), (
    _vm.serviceDetails.requestStatus == 'Sent For Approval' && _vm.userLevel == '1'
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.requestStatusError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (
    _vm.jobTypeMaster.length == 0 &&
    _vm.serviceDetails.onRejectStatus != '3' &&
    _vm.itemServiceDetails.length > 0
  ) ? _c('b-row', [_c('b-col', [(
    (_vm.serviceDetails.approvedStatus == 'Pending' ||
      _vm.serviceDetails.approvedStatus == 'Rejected' ||
      _vm.serviceDetails.approvedStatus == '' ||
      (_vm.userLevel == '1' &&
        (_vm.serviceDetails.approvedStatus == 'Sent For Approval' ||
          _vm.serviceDetails.approvedStatus == 'On_Hold'))) &&
    !_vm.disableBTN
  ) ? _c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px mrgtop-2per",
    attrs: {
      "disabled": _vm.disableBTN,
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.addServiceEst('Pending')
      }
    }
  }, [_vm._v("\n            Save\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', [(
    _vm.userLevel != '1' &&
    (_vm.serviceDetails.approvedStatus == 'Pending' ||
      _vm.serviceDetails.approvedStatus == 'Rejected' ||
      _vm.serviceDetails.approvedStatus == '')
  ) ? _c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px mrgtop-2per",
    attrs: {
      "id": "addButtonLoader1"
    },
    on: {
      "click": function($event) {
        _vm.addServiceEst('Sent For Approval')
      }
    }
  }, [_vm._v("\n            Send For Approval\n          ")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.jobTypeMaster.length <= 0 && _vm.serviceDetails.approvedStatus == 'Approved') ? _c('b-row', [_c('b-col', [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px mrgtop-2per",
    attrs: {
      "id": "addButtonLoader2"
    },
    on: {
      "click": _vm.jobType
    }
  }, [_vm._v("\n            Create Job Order\n          ")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.notValid != true && _vm.userLevel == '1') ? _c('md-layout', [_c('h3', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorNotApproved))])]) : _vm._e(), _vm._v(" "), (_vm.serviceDetails.onRejectStatus == '3') ? _c('md-layout', [_c('h3', {
    staticClass: "error"
  }, [_vm._v("This Job Order is Rejected 3 times..!")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop4",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose3
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop3",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose3
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop1",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose1
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30accb6a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/maintenance/serviceEstimation/serviceEstimation.vue
// module id = 2497
// module chunks = 0